const DATE_FORMAT_RECORD = {
  ko: "y\uB144 MMM d\uC77C",
  en: "MMM d, y"
};
const RELATED_DATE_FORMATS = [
  "yy-M-d",
  "yyMd",
  "yyyyMd",
  "yyyy-M-d",
  "yyMMdd",
  "yyMMd",
  "yy-MM-dd",
  "yy-MM-d",
  "yyyy-MM-dd",
  "yyyy-MM-d",
  "yyyyMMd",
  "yyyyMMdd"
];
const YEAR_MONTH_DATE_FORMAT_RECORD = {
  ko: "y\uB144 MMM",
  en: "MMMM, y"
};
const RELATED_YEAR_MONTH_DATE_FORMATS = [
  "yy-M",
  "yyM",
  "yyyyM",
  "yyyy-M",
  "yyMM",
  "yy-MM",
  "yyyy-MM",
  "yyyyMM"
];

export { DATE_FORMAT_RECORD, RELATED_DATE_FORMATS, RELATED_YEAR_MONTH_DATE_FORMATS, YEAR_MONTH_DATE_FORMAT_RECORD };
//# sourceMappingURL=date-format.mjs.map
